import { apiChat } from '@/services/api';
import { useQuery } from '@tanstack/react-query';

const useGetChats = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ['chats'],
    queryFn: () => apiChat.chat.getChats(),
    enabled
  });
};
export default useGetChats;
